export const home = {
  // Hero Section
  hero_title: 'Uw Digitale Toekomst Versterken',
  hero_subtitle: 'Toonaangevende IT-oplossingen en generatieve AI-diensten voor moderne bedrijven',
  hero_cta_primary: 'Ontdek Onze Oplossingen',
  hero_cta_secondary: 'Neem Contact Op',
  
  // Services Section
  services_title: 'Onze Diensten',
  services_subtitle: 'Uitgebreide IT-oplossingen op maat voor uw bedrijf',
  
  service_hardware_title: 'Hardware Oplossingen',
  service_hardware_desc: 'Enterprise-grade servers, werkstations en netwerkinfrastructuur',
  
  service_software_title: 'Software Diensten',
  service_software_desc: 'Zakelijke software, beveiligingsoplossingen en cloud diensten',
  
  service_it_title: 'IT Consulting',
  service_it_desc: 'Strategisch IT-advies en digitale transformatie diensten',
  
  service_ai_title: 'Generatieve AI',
  service_ai_desc: 'Geavanceerde AI-oplossingen en machine learning diensten',
  
  // Solutions Section
  solutions_title: 'IT Oplossingen',
  solutions_subtitle: 'End-to-end oplossingen voor uw bedrijfsbehoeften',
  
  solution_cloud_title: 'Cloud Diensten',
  solution_cloud_desc: 'Schaalbare cloud infrastructuur en migratie diensten',
  
  solution_security_title: 'Cyberbeveiliging',
  solution_security_desc: 'Uitgebreide beveiligingsoplossingen om uw bedrijf te beschermen',
  
  solution_infrastructure_title: 'Infrastructuur',
  solution_infrastructure_desc: 'Optimalisatie en beheer van IT-infrastructuur',
  
  solution_digital_title: 'Digitale Transformatie',
  solution_digital_desc: 'Moderniseer uw bedrijf met digitale technologieën',
  
  // AI Section
  ai_title: 'Generatieve AI Oplossingen',
  ai_subtitle: 'Transformeer uw bedrijf met geavanceerde AI-technologie',
  
  ai_consulting_title: 'AI Consulting',
  ai_consulting_desc: 'Strategisch AI-advies en implementatie planning',
  
  ai_automation_title: 'AI Automatisering',
  ai_automation_desc: 'Automatiseer bedrijfsprocessen met AI-technologie',
  
  ai_vision_title: 'Computer Vision',
  ai_vision_desc: 'Geavanceerde beeldherkenning en analyse oplossingen',
  
  ai_conversational_title: 'Conversationele AI',
  ai_conversational_desc: 'Intelligente chatbots en virtuele assistenten',
  
  // Infrastructure Section
  infrastructure_title: 'Infrastructuur Optimalisatie',
  infrastructure_subtitle: 'Bouw een robuuste en schaalbare IT-infrastructuur',
  infrastructure_desc: 'Onze infrastructuur optimalisatie diensten helpen u een betrouwbare, veilige en efficiënte IT-omgeving te creëren die groeit met uw bedrijf.',
  
  infrastructure_feature1_title: 'Netwerkontwerp',
  infrastructure_feature1_desc: 'Aangepaste netwerkarchitectuur voor optimale prestaties',
  
  infrastructure_feature2_title: 'Server Beheer',
  infrastructure_feature2_desc: '24/7 monitoring en onderhoud van uw servers',
  
  infrastructure_feature3_title: 'Cloud Integratie',
  infrastructure_feature3_desc: 'Naadloze integratie met cloud platforms',
  
  infrastructure_feature4_title: 'Disaster Recovery',
  infrastructure_feature4_desc: 'Uitgebreide back-up en hersteloplossingen',
  
  // Digital Transformation Section
  transformation_title: 'Digitale Transformatie',
  transformation_subtitle: 'Moderniseer uw bedrijf voor het digitale tijdperk',
  transformation_desc: 'Wij helpen organisaties hun digitale reis te navigeren met strategische planning, technologie implementatie en change management.',
  
  transformation_step1_title: 'Beoordeling',
  transformation_step1_desc: 'Evalueer uw huidige digitale volwassenheid',
  
  transformation_step2_title: 'Strategie',
  transformation_step2_desc: 'Ontwikkel een uitgebreid transformatie roadmap',
  
  transformation_step3_title: 'Implementatie',
  transformation_step3_desc: 'Voer oplossingen uit met minimale verstoring',
  
  transformation_step4_title: 'Optimalisatie',
  transformation_step4_desc: 'Continu verbeteren en schalen',
  
  // Featured Products Section
  products_title: 'Uitgelichte Producten',
  products_subtitle: 'Ontdek onze meest populaire hardware en software oplossingen',
  
  // CTA Section
  cta_title: 'Klaar om Uw IT-Infrastructuur te Transformeren?',
  cta_subtitle: 'Neem vandaag nog contact op met ons team van experts',
  cta_button: 'Offerte Aanvragen',
  
  // Partner Form
  form_title: 'Offerte Aanvragen',
  form_subtitle: 'Vul het onderstaande formulier in en ons team neemt binnen 24 uur contact met u op',
  form_name: 'Volledige Naam',
  form_email: 'E-mailadres',
  form_phone: 'Telefoonnummer',
  form_company: 'Bedrijfsnaam',
  form_service: 'Dienst van Interesse',
  form_service_placeholder: 'Selecteer een dienst',
  form_message: 'Bericht',
  form_message_placeholder: 'Vertel ons over uw project...',
  form_submit: 'Offerte Aanvragen',
  form_submitting: 'Verzenden...',
  form_success: 'Bedankt! Wij nemen binnenkort contact met u op.',
  form_error: 'Er is iets misgegaan. Probeer het opnieuw.',
  
  // Service Options
  service_option_hardware: 'Hardware Oplossingen',
  service_option_software: 'Software Diensten',
  service_option_it_services: 'IT Diensten',
  service_option_cloud: 'Cloud Diensten',
  service_option_security: 'Cyberbeveiliging',
  service_option_ai: 'Generatieve AI',
  service_option_consulting: 'IT Consulting',
  service_option_other: 'Anders',
};

export default home;
